import { useEffect } from 'react';

const BODY_CLASS_NOMINA_GUARD = 'nomina-guard-modal-open';

/**
 * Hook que añade una clase al body cuando el modal del guardrail de nómina está abierto.
 * Esto permite que el contenido de fondo (ej. BulkActionsBar) quede detrás del dimmer del modal.
 */
export const useNominaGuardModalBodyClass = (isOpen) => {
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add(BODY_CLASS_NOMINA_GUARD);
    } else {
      document.body.classList.remove(BODY_CLASS_NOMINA_GUARD);
    }
    return () => document.body.classList.remove(BODY_CLASS_NOMINA_GUARD);
  }, [isOpen]);
};

/**
 * Utilidad para validar si un documento puede ser eliminado según su estado en nóminas.
 * Si el documento está en una nómina (meta.nominaStatus.inNominaProcess tiene elementos),
 * no debe poder eliminarse.
 *
 * @param {Object|Object[]} documents - Documento o array de documentos a validar
 * @returns {{ canDelete: boolean, nominaNames: string[] }} - canDelete: false si alguno está en nómina; nominaNames: nombres únicos de nóminas
 */
export const getDocumentsInNominaInfo = (documents) => {
  const docs = Array.isArray(documents) ? documents : [documents];
  const nominaNamesSet = new Set();

  for (const doc of docs) {
    const inNominaProcess = doc?.meta?.nominaStatus?.inNominaProcess || [];
    if (inNominaProcess.length > 0) {
      inNominaProcess.forEach((item) => {
        if (item?.nominaName) {
          nominaNamesSet.add(item.nominaName);
        }
      });
    }
  }

  const nominaNames = [...nominaNamesSet];
  return {
    canDelete: nominaNames.length === 0,
    nominaNames,
  };
};
